export default __webpack_public_path__ + "static/media/jrc_alumni.415ee09c.ai";